const buttonActionMap = {
  F1: "PREVIEW",
  F2: "RESET",
  F3: "IN",
  F4: "OUT",

  F5: "TEAM_1_SCORE_UPDATE",
  F6: "TEAM_2_SCORE_UPDATE",

  F7: "ADDITIONAL_TIME_IN",
  F8: "ADDITIONAL_TIME_OUT",
  F9: "ADDITIONAL_TIME_PREVIEW",

  F10: "ATTACKING_THREAT_IN",
  F11: "ATTACKING_THREAT_OUT",
  F12: "ATTACKING_THREAT_PREVIEW",

  F13: "CARD_IN",
  F14: "CARD_OUT",
  F15: "CARD_PREVIEW",

  F16: "FREE_TEXT_IN",
  F17: "FREE_TEXT_OUT",
  F18: "FREE_TEXT_PREVIEW",

  F19: "GOALSCORER_IN",
  F20: "GOALSCORER_OUT",
  F21: "GOALSCORER_PREVIEW",

  F22: "MATCH_STATS_IN",
  F23: "MATCH_STATS_OUT",
  F24: "MATCH_STATS_PREVIEW",

  F25: "TEAM_NAMES_IN",

  F26: "SPONSOR_IN",
  F27: "SPONSOR_OUT",

  F28: "SUBSTITUTION_IN",
  F29: "SUBSTITUTION_OUT",
  F30: "SUBSTITUTION_CONTINUE",
  F31: "SUBSTITUTION_PREVIEW",

  F32: "WIN_PROBABILITY_IN",
  F33: "WIN_PROBABILITY_OUT",
  F34: "WIN_PROBABILITY_PREVIEW"
};

export default buttonActionMap;